module.exports = "<svg viewBox=\"0 0 24 24\"><polygon points=\"5.1231456 6.32943568 2.86323447 8.46718624 11.5186981 17.6172615 20.8632345 8.5123409 18.6923073 6.28428102 11.6090173 13.1859389\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./components/UI/Icon/images/chevron.svg
// module id = 769
// module chunks = 0